<div class="payment-powered-by-wrapper">
    <img src="../../../assets/icons/powered-by-naka-icon.svg" alt="powered-by-icon" />
</div>
